module.exports = __webpack_public_path__ + "img/software_zola.1d0546e5.jpg";